// eslint-disable-next-line
export var noop = function noop() {};